var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instgram_post"},[_c('a',{attrs:{"href":"#!"}},[_c('i',{staticClass:"fab fa-instagram"}),_c('img',{attrs:{"src":_vm.instagramImg,"alt":"img"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }